<script>
	// import Word from './Word.svelte';
	import Word2 from './Word2.svelte';
	import { Solver } from './solver.js';
	// import { runSimulation } from './simulate.js';

	let words = ['','','','','','','','','',''];
	let colors = ['','','','','','','','','',''];
	let num_words = 1;

	let solution_size = 0;
	let solution = undefined;

	function solve() {
		let solver = new Solver();
		for (let i = 0; i < num_words; ++i) {
			console.log(words[i], colors[i]);
			solver.feed(words[i], colors[i]);
		}
		const soln = solver.bestWords6();
		solution_size = soln.length;
		solution = soln.slice(0, 20);
	}

	function reset() {
		location.reload();
	}
</script>

<svelte:head>
	<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Slab">
</svelte:head>

<main>
	<h1>CHEATLE</h1>

	<hr/>

	<ol>
		<li>Enter letters into the boxes.</li>
		<li>Tap the &#x1F58C; to switch into Paint mode.</li>
		<li>Tap the letters to change their colors.</li>
	</ol>

	<div style="height: 1em"/>

	{#each Array(num_words) as _, i}
		<Word2
			bind:value={words[i]}
			bind:color={colors[i]}
		/>
		<div style="height: 5px"/>
	{/each}

	<div style="height: 15px"/>

	<button on:click={() => {if (num_words < 10) num_words += 1}}>
		Add another word
	</button>

	<div style="height: 5px"/>

	<button on:click={solve}>
		Solve
	</button>

	<div style="height: 5px"/>

	<button on:click={reset}>
		Reset
	</button>

	{#if solution != undefined}
		{#if solution_size > 0}
			<p>
				{solution_size} words match this Wordle.
			</p>
		{:else}
			<p>
				No words match this Wordle!
			</p>
		{/if}
		<ol>
			{#each solution as soln}
				<li>{soln.word}</li>	
			{/each}
		</ol>
	{/if}

	<p>
		If you like Cheatle, please consider <a href="https://www.buymeacoffee.com/evanperrygrove">making a small donation.</a>
		Your donation will help keep this website alive.
	</p>
</main>

<style>
	:root {
		--green: #538d4e;
		--yellow: #b59f3b;
		--gray: #3a3a3c;
		--black: #121213;
	}

	:global(body) {
		margin: 0;
		padding: 0;
		background-color: var(--black);
		color: white;
	}

	main {
		width: 100%;
		text-align: center;
	}

	a {
		color: lightskyblue;
	}

	h1 {
		font-family: 'Roboto Slab', serif;
		color: white;
		text-align: center;
	}

	button {
    background-color: var(--black);
    padding: 5px;
		margin: 0;
    height: 2em;
		width: auto;
    color: white;
    font-size: 1.2em;
    border: 2px solid var(--gray);
		min-width: 250px;
  }

	button:active {
		background-color: var(--black);
		filter: brightness(110%);
  }

	ol {
		color: white;
	}
</style>
